import React from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import toastr from "toastr"
import "toastr/build/toastr.min.css"

function Description(props) {
    const { product } = props

    const copyDescText = (e) => {
        e.preventDefault()
        const el = document.createElement('textarea')
        el.value = product.description
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)

        window.analytics.track("Product description copied", { product: {
            productName: product.name,
            productId: product.id,
            productCode: product.code,
            providerName: product.supplier.nombreComercial,
            family: product.familyId,
            category: product.categoryID,
            subcategory: product.subcategoryId,
            retailPrice: product.retailPrice,
            description: product.description
        }})

        toastr.success("Descripción del producto copiada correctamente!", "¡Éxito!")
    }

    return (
        <Tabs selectedTabClassName="show" selectedTabPanelClassName="active show">
            <div className="product-details-tab">
                <TabList className="nav nav-pills justify-content-center">
                    <Tab className="nav-item">
                        <span className="nav-link"> Descripción</span>
                    </Tab>
                </TabList>

                <div className="tab-content">
                    <TabPanel className="tab-pane">
                        <div className="product-desc-content">
                            <div className="copy-desc text-right" onClick={copyDescText}>Copiar</div>
                            <h3>Información del producto</h3>
                            <p>{product.description}</p>
                        </div>
                    </TabPanel>
                </div>
            </div>
        </Tabs>
    )
}

export default Description
